export interface TopPanelProps {
  ergeonUrl: string;
}

export interface TopPanelLinkProps {
  href: string;
  children: React.ReactNode;
  isActive?: boolean;
}

export interface PhoneLinkProps {
  phoneNumber?: string;
}

export interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  ergeonUrl: string;
}

export interface TopPanelRightSideProps {
  ergeonUrl: string;
}
